import Error from '../model/Error';
import axios from 'axios';

export default class ChildDuplicationRepository {
    static duplicate(childIds, targetKindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .post('/children-duplication', {
                    targetKindergartenId,
                    children: childIds
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
